module.exports = __webpack_public_path__ + "static/media/autopilot-robot-logo-cropped-for-ico-256.8eff14a7.png";